/**!
 * Developed by : Igor Ivanovic, Ivan Milos
 * Date: 9/5/13
 * @copyright : Nivas ltd.
 * www.nivas.hr
 *
 * update 'select box' after init from outside:
 *	$('#accommodation_search input[name='+ix+']').val(argObj[ix]);
 *	$('#accommodation_search input[name='+ix+']').trigger('custom_change');
 */
(function($){

    /**
     * pagination constructor
     */
    function NivasSelect(options,selector){

        this.settings = $.extend({
            elementClass : 'nvsSel',
            onSelect : function( value, text, model ){

            }
        }, options);
        this._element = $( selector );
        this._container = null;
        this._currentIndex = null;
        this._name = this._element.attr("name");
        this._id = this._element.attr("id");
        this._listContainer = null;
        this._selectField = null;
        this._timeout = null;
        this._model = [];
        this._init();
    }

    /**
     * Prototype
     */
    NivasSelect.prototype = {
        /**
         * Initialize
         */
        _init : function(){
            var self = this;

            /**
             * parse
             */

            this._element.find('option').each(function(i,v){
                var c = $(this), s = c.attr("selected"), t = c.text(), v = c.attr("value");
                if(s !== undefined){
                   self._currentIndex = i;
                }
                self._model.push({
                    selected :  s !== undefined,
                    text : t,
                    value : v,
                    def : c.attr("value") === undefined,
                    index : i
                });
            });
            /**
             * Default
             */
            if( self._currentIndex === null ){
                self._currentIndex = 0;
            }
            /**
             * Parse the other view
             */
            this._parse();
            /**
             * Bind events;
             */
            this._bindEvents();
        },

        /**
         * Get index
         */
        _getModelByIndex : function(index){
            var l = this._model.length, c = null;
            for(var i = 0; i <= l; ++i){
                c = this._model[i];
                if(c.index == index){
                   return c;
                }
            }
            return null;
        },

        /**
         * Get current val
         */
        _getCurrentModel : function(){
            var current = this._getModelByIndex(this._currentIndex);
            if( current ){
                return current;
            }
            return null;
        },

        /**
         * Parse
         */
        _parse : function(){
            var model = this._getCurrentModel();
            if( !model ){
                throw new Error('Selector must have options');
            }
            this._element.wrap('<div class="' + this.settings.elementClass + '"></div>');
            this._container = this._element.parent();
            this._selectField = $('<a href="#" class="selectField" data-index="'+model.index+'"><span>'+model.text+'</span></a>');
            this._container.append(this._selectField);
            var str = '<ul>';
            $.each(this._model, function(i,v){
                if (i==model.index){
                    str += '<li class="on" data-index="'+i+'"><a>' + v.text + '</a></li>';
                }
                else {
                    str += '<li data-index="'+i+'"><a>' + v.text + '</a></li>';
                }
            });
            str += '</ul>';
            this._listContainer = $(str);
            this._container.append(this._listContainer);
            this._element.remove();
            this._element = $('<input type="hidden" name="'+this._name+'" value="'+model.value+'" />');
            if(this._id !== undefined) {
                this._element.attr('id', this._id);
            }
			
			var self = this;
			this._element.on('custom_change', function(el)
								{
									var v = this.value;
									
									var len = self._model.length;
									for(var i=0; i<len; i++)
									{
										if(self._model[i].value == v && self._model[i].selected !== true)
										{
											self._changeIndex(self._model[i].index, true, false);
											return;
										}
									}
								}
							);
			
            this._container.append(this._element);
        },

        /**
         * Scroll to focused option
         */
        _scrollToFocused : function(){
            var posFocus = this._listContainer.find('li.focus').position(),
                posTop = posFocus.top + this._listContainer.find('li.focus').height();
            
            if( posTop > this._listContainer.height() || posFocus.top < 0 ) {
                this._listContainer.animate({ 
                    scrollTop: posFocus.top 
                }, 200);                
            }
        },

        /**
         * Set focused option to active option without closing the dropdown
         */
        _setFocusedToActive : function(){
            var index = parseInt(this._listContainer.find('li.focus').attr('data-index'));
            this._changeIndex(index, false);
            this._scrollToFocused();
        },

        /**
         * Bind Navigation Keys
         */
        _bindNavigationKeys : function(){
            var self = this;

            $(window).bind('keydown.navigationKeys',function(e) {

                // enter, page up, page down, end, home, arrow down, arrow up
                if( e.which == 13 || e.which == 33 || e.which == 34 || 
                    e.which == 35 || e.which == 36 || e.which == 38 || 
                    e.which == 40 ) {      
                    e.preventDefault();
                }

                // ctrl + alt + arrow up
                if(e.altKey && e.ctrlKey && e.which == 38) {
                    self._close(true);
                }
            });

            $(window).bind('keyup.navigationKeys',function(e) {
                switch (e.which){
                    // tab, enter, esc
                    case 9:
                    case 13:
                    case 27:
                        var index = parseInt(self._listContainer.find('li.focus').attr('data-index'));
                        self._changeIndex(index, true);
                        break;

                    // page up
                    case 33:
                        if ( self._listContainer.find('li.focus').prevAll().length > 4 ){
                            self._listContainer.find('li.focus').removeClass('focus').prevAll().eq(4).addClass('focus');
                        } else {
                            self._listContainer.find('li.focus').removeClass('focus');
                            self._listContainer.find('li:eq(0)').addClass('focus'); 
                        }

                        self._setFocusedToActive();
                        break;

                    // page down
                    case 34:
                        if ( self._listContainer.find('li.focus').nextAll().length > 4 ){
                            self._listContainer.find('li.focus').removeClass('focus').nextAll().eq(4).addClass('focus');
                        } else {
                            self._listContainer.find('li.focus').removeClass('focus');
                            self._listContainer.find('li:last-child').addClass('focus'); 
                        }

                        self._setFocusedToActive();
                        break;

                    // end
                    case 35:
                        self._listContainer.find('li.focus').removeClass('focus');
                        self._listContainer.find('li:last-child').addClass('focus');
                        self._setFocusedToActive();
                        break;

                    // home
                    case 36:
                        self._listContainer.find('li.focus').removeClass('focus');
                        self._listContainer.find('li:eq(0)').addClass('focus');
                        self._setFocusedToActive();
                        break;

                    // arrow left || arrow up
                    case 37:
                    case 38:
                        if ( self._listContainer.find('li.focus').prev('li').length && !(e.altKey && e.ctrlKey) ){
                            self._listContainer.find('li.focus').removeClass('focus').prev('li').addClass('focus');
                            self._setFocusedToActive();
                        }
                        break;

                    // arrow right || arrow down
                    case 39:
                    case 40:
                        if ( self._listContainer.find('li.focus').next('li').length && !(e.altKey && e.ctrlKey) ){
                            self._listContainer.find('li.focus').removeClass('focus').next('li').addClass('focus');
                            self._setFocusedToActive();
                        }
                        break;
                }
            });

        },

        /**
         * Bind Letter Keys
         */
        _bindLetterKeys : function(){
            var self = this,
                keyStr = '',
                key = '',
                keyData = 'asdfghjklčćžqwertzuiopšđyxcvbnm1234567890';

            /**
             * Reset typed string after pressing navigation keys
             */
            $(window).bind('keyup.letterKeys',function(e) {
                // page up, page down, end, home, arrow left, arrow up, arrow right, arrow down
                if( e.which == 33 || e.which == 34 || e.which == 35 || 
                    e.which == 36 || e.which == 37 || e.which == 38 || 
                    e.which == 39 || e.which == 40 ) {      
                    keyStr = '';
                    clearTimeout(self._timeout);
                }
            });

            /**
             * Binding on 'keypress' is the only way to get the correct charCode.
             */
            $(window).bind('keypress.letterKeys',function(e) {
                key = String.fromCharCode(e.which).toLowerCase();

                if( keyData.search(key) !== -1 ){
                    /**
                     * Combine typed characters into a string. Make an exception 
                     * when user repeatedly presses the same key. This allows 
                     * navigating through options beginning with the same letter.
                     */
                    if( !(keyStr.length == 1 && keyStr === key) ){
                        keyStr = keyStr + key;
                    }

                    /** 
                     * Keep typed string for a short time, then reset.
                     */
                    clearTimeout(self._timeout);
                    self._timeout = setTimeout(function(){
                        keyStr = '';
                    }, 1400);

                    /**
                     * Search for the next option beginning with typed string.
                     * Starts the search from focused option.
                     */
                    var ix = parseInt(self._listContainer.find('li.focus').attr('data-index')),
                        isFound = false;

                    for( var i=ix+1; i<self._model.length; i++ ) { 
                        var subStr = self._model[i].text.substring(0, keyStr.length).toLowerCase();
                        if( keyStr === subStr ){
                            self._changeIndex(i, false);
                            self._listContainer.find('li.focus').removeClass('focus');
                            self._listContainer.find('li:eq('+i+')').addClass('focus');
                            self._scrollToFocused();
                            isFound = true;
                            break;
                        }
                    }

                    if( !isFound ){
                        for( var i=0; i<ix; i++ ) { 
                            var subStr = self._model[i].text.substring(0, keyStr.length).toLowerCase();
                            if( keyStr === subStr ){
                                self._changeIndex(i, false);
                                self._listContainer.find('li.focus').removeClass('focus');
                                self._listContainer.find('li:eq('+i+')').addClass('focus');
                                self._scrollToFocused();
                                break;
                            }
                        }
                    }

                }
            });

        },

        /**
         * Bind open options dropdown on arrow down when the field is focused
         */
        _bindOpeningKeys : function(){

            var self = this,
                key = '',
                keyData = 'asdfghjklčćžqwertzuiopšđyxcvbnm1234567890';;

            this._selectField.bind('keydown.openingKeys', function(e){
                if(e.which == 37 || e.which == 38 || e.which == 39 || e.which == 40 ){
                    e.preventDefault();
                    self._open();
                }
            });

            this._selectField.bind('keypress.openingKeys',function(e) {
                key = String.fromCharCode(e.which).toLowerCase();
                if( keyData.search(key) != -1 ){
                    self._open();
                }
            });
        },

        /**
         * Bind events
         */
        _bindEvents : function(){
            var self = this;

            /**
             * Click open
             */
            this._selectField.on('click', function(e){
                e.preventDefault();

                if ( self._container.hasClass('open') ){
                    self._close(true);
                } else {
                    self._open();
                }

            });

            this._bindOpeningKeys();

            /**
             * On list
             */
            this._listContainer.on('click','li', function(e){
                e.preventDefault();
                var index = parseInt($(this).attr('data-index'));
                self._changeIndex(index, true);
            });
        },

        /**
         * Open options dropdown
         */
        _open : function(){
            var self = this;

            /**
             * Dropdown positioning
             */            
            var offsetTop = self._container.offset().top, 
                fromWinTop = offsetTop - $(window).scrollTop(), 
                fieldH = parseInt( self._listContainer.css('top') ),
                listH = self._listContainer.height();
             
            if ( fromWinTop+fieldH+listH > $(window).height() && fromWinTop > listH ){
                self._container.addClass('open-bottom');
            } 
            else if ( offsetTop+fieldH+listH > $(document).height() ){
                self._container.addClass('open-bottom');
            }
            self._container.addClass('open');

            /**
             * Focus option
             */
            self._listContainer.find('li.on').addClass('focus');
            self._scrollToFocused();

            self._listContainer.find('li').hover(function(){
                $(this).addClass('focus').siblings().removeClass('focus');
            }, function(){});

            /**
             * Bind keys
             */
            self._selectField.unbind('.openingKeys');
            self._bindNavigationKeys();
            self._bindLetterKeys();

            /**
             * Clicking anywhere on the document closes the custom dropdown list
             */
            $(document).bind('click.customSelect', function(e){
                if( $(e.target).closest('.'+self.settings.elementClass).length == 0 ) {
                    self._close(true);
                } 
                else if ( !$(e.target).closest('.'+self.settings.elementClass).is(self._container) ) {
                    self._close(false);
                }
            });
        },

        /**
         * Close options dropdown
         */
        _close : function(unbind){
            this._container.removeClass('open open-bottom');
            this._listContainer.find('li.focus').removeClass('focus');
            if (unbind){
                $(document).unbind('click.customSelect');
                $(window).unbind('.navigationKeys');
                $(window).unbind('.letterKeys');
                this._bindOpeningKeys();               
            }
        },

        /**
         * Change index
         */
        _changeIndex : function(index, doClose, triggerChangeEvent){
            $.each(this._model, function(i,v){
                v.selected = false;
            });
            var model = this._getModelByIndex(index);
			
			if(typeof(triggerChangeEvent)=='undefined')
			{
				triggerChangeEvent = true;
			}
			
            if( model ){
				
				//this._currentIndex = model.index; //d
				
                model.selected = true;
                this._selectField.attr('data-index',model.index);
                this._selectField.html('<span>'+model.text+'</span>');
				
                if(triggerChangeEvent)
					this._element.val(model.value).trigger('change');
				
				
                this._listContainer.find('li.on').removeClass('on');
                this._listContainer.find('li[data-index="'+model.index+'"]').addClass('on');
                if(doClose) { 
                    this._close(true); 
                }
                this.settings.onSelect(model.value, model.text, model);
            }
        }
    };

    /**
     * Extend
     */
    $.fn.nivasSelect = $.extendable(NivasSelect);
}(jQuery));